<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <div class="card card-success rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-success border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-center">
                        <div class="text-center">
                            <div class="fs-1 fw-bold"> {{ riskData?.totalFailures || 0 }}</div>
                            <div>Total Failures</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-center">
                        <div class="text-center">
                            <div class="fs-1 fw-bold"> {{ riskData?.appFailures || 0 }}</div>
                            <div>App Failures</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-total rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-primary border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-center">
                        <div class="text-center">
                            <div class="fs-1 fw-bold"> {{ riskData?.acquirerCount || 0 }}</div>
                            <div>Acquirer Failures</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-failed rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-danger border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-center">
                        <div class="text-center">
                            <div class="fs-1 fw-bold"> {{ riskData?.issuerFailures || 0 }}</div>
                            <div>Issuer Failures</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
                <p class="primaryColor fs-5 fw-bold"> Failure by Reasons</p>
                <div class="">
                    <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="barChartSettings.data"
                        [gradient]="barChartSettings.gradient" [xAxis]="barChartSettings.showXAxis"
                        [yAxis]="barChartSettings.showYAxis" [legend]="barChartSettings.showLegend"
                        [showXAxisLabel]="barChartSettings.showXAxisLabel" [barPadding]="500"
                        [showYAxisLabel]="barChartSettings.showYAxisLabel" [xAxisLabel]="barChartSettings.xAxisLabel"
                        [yAxisLabel]="barChartSettings.yAxisLabel" [tooltipDisabled]="false">
                    </ngx-charts-bar-vertical>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
                <p class="primaryColor fs-5 fw-bold">Country Wise Failures</p>
                <div>
                    <ngx-charts-bar-horizontal [scheme]="colorScheme" [results]="countryWiseFailureData"
                        [gradient]="countryWiseFailurePieChartSettings.gradient"
                        [xAxis]="true" [yAxis]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                        [xAxisLabel]="'Count'" [yAxisLabel]="'Country'" [tooltipDisabled]="false">
                    </ngx-charts-bar-horizontal>
                </div>
            </div>
        </div>
    </div>
</div>